import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Edit"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-edit',
    templateUrl: './icon-cash-edit.component.html',
    styleUrls: ['./icon-cash-edit.component.scss'],
    standalone: false
})
export class IconCashEditComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
